import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class HomeExploreCardModel extends Model {
    constructor(
        public id: number = 0,
        public label: string = "",
        public link: string = "",
        public imageUrl: string = "",
        public title: string = "",
        public info: string = "",
        public date: string = "",
    ) {
        super();
    }

    public static create(model: Partial<HomeExploreCardModel>): HomeExploreCardModel {
        return createModel<HomeExploreCardModel>(HomeExploreCardModel, {
            ...model
        });
    }
}
